var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafeHygienic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    stroke: "#000",
    strokeWidth: 2.5,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "safe-hygienic_svg__shape",
    fill: "#134a81",
    d: "M34.65 12.466v.023c6.115 3.151 13.3 4.665 19.308 5.09v17.872c0 4.769-.455 8.174-2.78 11.47-2.8 3.964-8.233 7.701-16.573 11.386l.044-.021.001.02-.022-.01-.023.01v-.02C26.31 54.61 20.903 50.879 18.116 46.92c-2.32-3.294-2.774-6.7-2.774-11.469V17.578c6.015-.426 13.2-1.947 19.308-5.112l-.046.023.001-.023.023.012.022-.012z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M31.73 36.678l-5.002-4.995-2.755 2.751 7.757 7.758 2.449-2.446 11.094-11.101-2.751-2.755-8.343 8.343z"
  }))));
}
export default SvgSafeHygienic;